import * as z from "zod";

export const acceptFedexAgreement = {
  name: "acceptFedexAgreement" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
